import React from "react";
import Typography from "@material-ui/core/Typography";
import TablaTagSinFactor from "../components/TablaTagSinFactor";

class ConteosSignificativos extends React.Component {
    constructor(props) {
        super(props);
        this.state={

        }
    }


    handleChangeLoading = () =>{
        //NO BORRAR
    }



    render() {
        return(
            <div>
                <Typography variant="h4" gutterBottom>
                    Conteos significativos
                </Typography>
                <TablaTagSinFactor origen={"conteo_significativos"} tag={''} tipo={'desagrupado'} handleLoading={this.handleChangeLoading}/>
            </div>
        )
    }

}

export default ConteosSignificativos;